import { DefaultState } from '@src/redux/types'

import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [TYPES.QUIZ_BY_ID]: DefaultState<`${typeof API.QUIZ}{id}`, 'get'>
  [TYPES.QUIZ_ALL]: DefaultState<`${typeof API.QUIZ_ALL}`, 'get'>
  [TYPES.QUIZ_LIST]: DefaultState<`${typeof API.QUIZ}`, 'get'>
  [TYPES.QUIZ_CACHE_ALL]: DefaultState<`${typeof API.QUIZ_CACHE_ALL}`, 'get'>
  // [TYPES.QUIZ_RESULT_OPEN]: DefaultState<`${typeof API.QUIZ_RESULT_OPEN}`, 'get'>
  // [TYPES.QUIZ_RESULTS]: DefaultState<`${typeof API.QUIZ_RESULTS}`, 'get'>
  [TYPES.QUIZ_TYPES]: DefaultState<`${typeof API.QUIZ_TYPES}`, 'get'>
} = () => ({
  [TYPES.QUIZ_BY_ID]: defaultState(),
  [TYPES.QUIZ_ALL]: defaultState(),
  [TYPES.QUIZ_LIST]: defaultState(),
  [TYPES.QUIZ_CACHE_ALL]: defaultState(),
  // [TYPES.QUIZ_RESULT_OPEN]: defaultState(),
  // [TYPES.QUIZ_RESULTS]: defaultState(),
  [TYPES.QUIZ_TYPES]: defaultState(),
})
